<template>
  <div>
    <div class="con-tab-ejemplo">
      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.contractDate") }}</h6>
          <p>{{ _contract.contractDate }}</p>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.contractNo") }}</h6>
          <p>{{ _contract.contractNo }}</p>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.contractName") }}</h6>
          <p>{{ _contract.contractName }}</p>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.customer.dataForm.idCardNumber") }}</h6>
          <p>{{ _contract.borrower.idCardNumber }}</p>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.contactNumber") }}</h6>
          <p> {{ _contract.contactNumber }}</p>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.project") }}</h6>
          <p>{{ _contract.project }}</p>
        </div>
      </div>
        <!--  -->
      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.faculty") }}/{{ $t("sections.accounting.dataForm.curriculum") }}</h6>
          <p> {{ _contract.curriculum }}</p>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t('sections.accounting.dataForm.periods.begin') }} - {{ $t('sections.accounting.dataForm.periods.end') }}</h6>
          <p>{{ _contract.periods }}</p>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.contractAmount") }}</h6>
          <p>{{ _contract.contractAmount }}</p>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t('sections.accounting.dataForm.loan.interestRate') }}</h6>
          <p>{{ interestRate }}</p>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t('sections.accounting.dataForm.loan.penaltyRate') }}</h6>
          <p>{{ penaltyRate }} </p>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t('sections.accounting.dataForm.loan.interestRateEir') }}</h6>
          <p>{{ interestRateEir }} </p>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t('sections.customer.dataForm.educationStatus') }}</h6>
          <p>{{ _contract.educationStatus }} ({{ _contract.educationStatusExternal }})</p>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t('sections.customer.dataForm.forecastDate') }}</h6>
          <p>{{ _contract.forecastDate }} </p>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-1/2">
          <h6>{{ $t("sections.accounting.dataForm.accoNo") }}</h6>
          <p>{{ _contract.accoNo || "-" }}</p>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col w-full sm:w-full">
          <h6>{{ $t("sections.accounting.dataForm.loan.paymentDescription") }}</h6>
          <p>{{ _contract.loanTypeName }}</p>
        </div>
      </div>
    </div>
    <div class="con-tab-ejemplo">
      <div class="vx-row mb-4 flex">
        <div class="vx-col w-full flex-1">
          <vs-alert :title="$t('suggestion.accountClosingDetails.title', {date: _contract.loanLastUpdate})" color="danger" close-icon="icon-x" icon-pack="feather">
            <p v-html="accountClosingDetails"></p>
          </vs-alert>
        </div>
        <div class="vx-col w-full flex-1">
          <vs-alert :title="$t('suggestion.restructuringDetail.title', {date: _contract.restructuringDate})" color="success" close-icon="icon-x" icon-pack="feather" v-if="_contract.restructuring">
            <p v-html="restructuringDetail"></p>
          </vs-alert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment';
const _ = require('lodash');
import { round } from '@/utils'
import {createNamespacedHelpers} from 'vuex'
const { mapState: mapAccountingState} = createNamespacedHelpers('Accounting');
export default {
  computed:{
    ...mapAccountingState([
      'status',
      'contract',
    ]),
    _contract() {
      const vm = this;
      if(!vm.contract) return null;
      return {
        ...vm.contract,
        contactNumber: vm.contract.borrower ? `${vm.contract.borrower.phone} ${vm.contract.borrower.mobile}` : '-',
        project: vm.contract.borrower ? vm.contract.borrower.project.nameTh : '-',
        curriculum: vm.contract.curriculum ? `${vm.contract.curriculum.faculty.nameTh}/${vm.contract.curriculum.nameTh}` : '-',
        periods: `${vm.contract.periodTermStart}/${vm.contract.periodYearStart} - ${vm.contract.periodTermEnd}/${vm.contract.periodYearEnd}`,
        contractLoanDate: vm.contract.contractLoanDate ? moment(vm.contract.contractLoanDate).format("DD-MM-YYYY") : "-",
        contractAmount: vm.contract.contractAmount ? vm.$options.filters.numberFormat(vm.contract.contractAmount) : "-",
        educationStatus: vm.contract.educationStatusName,
        educationStatusExternal: vm.contract.educationStatusExternalName,
        forecastDate: vm.contract.forecastDate ? moment(vm.contract.forecastDate).format("DD-MM-YYYY") : "-",
        graduationDate: vm.contract.graduationDate ? moment(vm.contract.graduationDate).format("DD-MM-YYYY") : "-",
        loanLastUpdate: vm.contract.loan ? moment(vm.contract.loan.lastUpdate).format("DD-MM-YYYY") : "-",
        restructuringDate: vm.contract.restructuring ? moment(vm.contract.restructuringDetail.restructuringDate).format("DD-MM-YYYY") : "-",
        loanType: vm.contract.loan ? vm.contract.loan.loanType : "-",
        loanTypeTxt: vm.contract.loan ? vm.contract.loan.loanType : "-",
        loanTypeName: vm.contract.loan ? vm.contract.loan.loanTypeName : "-",
      }
    },
    interestRate() {
      const vm = this
      let interestRate = ""
      if(vm.contract.loan.interestRateDetails){
        const interestRateDetail = _.orderBy(vm.contract.loan.interestRateDetails , ['interestDate'], ['desc']).find(res => {
          let interestDate = moment(res.interestDate)
          return moment().isSameOrAfter(interestDate)
        })
        interestRate = ( interestRateDetail ? interestRateDetail.interestRate : 0)
      }
      return this.$options.filters.convPerYear(interestRate);
    },
    penaltyRate() {
      const vm = this
      let penaltyRate = ""
      if(vm.contract.loan.interestRateDetails){
        const interestRateDetail = _.orderBy(vm.contract.loan.interestRateDetails , ['interestDate'], ['desc']).find(res => {
          let interestDate = moment(res.interestDate)
          return moment().isSameOrAfter(interestDate)
        })
        penaltyRate = ( interestRateDetail ? interestRateDetail.penaltyRate : 0)
      }
      return this.$options.filters.convPerYear(penaltyRate);
    },
    interestRateEir() {
      const vm = this
      let interestRateEir = ""
      if(vm.contract.loan){
        interestRateEir = vm.contract.loan.interestRateEir
      }
      return this.$options.filters.convPerYear(interestRateEir);
    },
    accountClosingDetails() {
      const vm = this
      const {
        restructuringFeeRemain,
        restructuringPenaltyRemain,
        restructuringInterestRemain,
        restructuringPrincipleRemain,
        accruedFeeRemain,
        accruedPenaltyRemain,
        accruedInterestRemain,
        principleRemain,
        outstandingBalanceRemain,
        outstandingBalanceRestructuringRemain,
        balanceRemain,
      } = vm.contract.loan || {
        restructuringFeeRemain: 0,
        restructuringPenaltyRemain: 0,
        restructuringInterestRemain: 0,
        restructuringPrincipleRemain: 0,
        accruedFeeRemain: 0,
        accruedPenaltyRemain: 0,
        accruedInterestRemain: 0,
        principleRemain: 0,
        outstandingBalanceRemain: 0,
        outstandingBalanceRestructuringRemain: 0,
        balanceRemain: 0,
      }
      let total = restructuringPrincipleRemain + accruedFeeRemain + accruedPenaltyRemain + accruedInterestRemain + principleRemain + restructuringFeeRemain + restructuringPenaltyRemain + restructuringInterestRemain
      const { numberFormat } = vm.$options.filters;
      let accountClosingDetails = `
        ยอดเงินต้นคงเหลือ: ${numberFormat(principleRemain)} ${restructuringPrincipleRemain > 0 ? `(${numberFormat(restructuringPrincipleRemain)})` : ''} บาท<br>
        ยอดค่าธรรมเนียมคงเหลือ: ${numberFormat(accruedFeeRemain)} ${restructuringPenaltyRemain > 0 ? `(${numberFormat(restructuringFeeRemain)})` : ''} บาท<br>
        ยอดเบี้ยปรับคงเหลือ: ${numberFormat(accruedPenaltyRemain)} ${restructuringPenaltyRemain > 0 ? `(${numberFormat(restructuringPenaltyRemain)})` : ''} บาท<br>
        ยอดดอกเบี้ยคงเหลือ: ${numberFormat(accruedInterestRemain)} ${restructuringInterestRemain > 0 ? `(${numberFormat(restructuringInterestRemain)})` : ''} บาท<br>
        ยอดเรียกเก็บคงเหลือ: ${numberFormat(outstandingBalanceRemain)} ${outstandingBalanceRestructuringRemain > 0 ? `(${numberFormat(outstandingBalanceRestructuringRemain)})` : ''} บาท<br>
        ยอดดอกเบี้ยรับล่วงหน้า: ${numberFormat(balanceRemain)} บาท<br>
        ยอดชำระเพื่อปิดบัญชี: ${numberFormat(round(total, 2))} บาท<br>
      `
        return accountClosingDetails || ""
    },
    restructuringDetail() {
      const vm = this
      const {
        restructuringFeeRemain,
        restructuringPenaltyRemain,
        restructuringInterestRemain,
        accruedFeeRemain,
        accruedPenaltyRemain,
        accruedInterestRemain,
        principleRemain,
        remark,
      } = vm.contract.restructuringDetail || {
        restructuringFeeRemain: 0,
        restructuringPenaltyRemain: 0,
        restructuringInterestRemain: 0,
        accruedFeeRemain: 0,
        accruedPenaltyRemain: 0,
        accruedInterestRemain: 0,
        principleRemain: 0,
        remark: "",
      }
      const { numberFormat } = vm.$options.filters;
      let restructuringDetail = `
        ยอดเงินต้นยกมา: ${numberFormat(principleRemain)} บาท<br>
        ยอดค่าธรรมเนียมยกมา: ${numberFormat(accruedFeeRemain + restructuringFeeRemain )} บาท<br>
        ยอดเบี้ยปรับยกมา: ${numberFormat(accruedPenaltyRemain + restructuringPenaltyRemain)} บาท<br>
        ยอดดอกเบี้ยยกมา: ${numberFormat(accruedInterestRemain + restructuringInterestRemain)} บาท<br>
        หมายเหตุ: ${remark}<br>
      `
        return restructuringDetail || ""
    },
  },
}
</script>

<style scoped>
  .vx-coll-fixed-hight{
    display:block;
    width:100%;
    height:400px;
    overflow: auto;
  }
</style>
